import { Box, Typography } from '@mui/material';
import { AddCredentialButton, CredentialsSection } from './CredentialsSection';

/**
 * `/admin/keys` — the access keys that read private and internal repositories, as metadata
 * only: the secret is stored once and never shown.
 */
export const AdminKeysPage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h1" component="h1">
        Access keys
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 720 }}>
        A private or internal repository is read with one of these. The secret is stored once and never shown.
      </Typography>
    </Box>

    <Box>
      <AddCredentialButton />
    </Box>
    <CredentialsSection />
  </Box>
);
